import React from "react";
import {
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Button
} from '@mui/material';
import OptionsModal from './OptionsModal'
import EventAdditionalPriceDefinitions from '../../../models/EventAdditionalPriceDefinitions';
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import EventAdditonalPriceTypes from '../../../models/EventAdditionalPriceType';
import MemberAgeGroups from '../../../models/MemberAgeGroups';
import MemberGroupTypes from '../../../models/MemberGroupTypes';

class Options extends React.Component<any, any> {

    componentDidMount() {
        this.props.fetch()
        this.props.fetchPriceTypes()
        this.props.fetchAgeGroups()
    }

    public render() {
        const columnNames: string[] = ['Option', 'Bezeichnung', 'Teilnehmergruppe', 'Altersklasse', 'Kontingente', 'Preis', 'Aktionen']

        let eventAdditionalPriceTypes: JSX.Element[] = (this.props.eventAdditionalPriceTypes as EventAdditonalPriceTypes[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.priceTypeDescription}</MenuItem>
        })

        let ageGroups: JSX.Element[] =  (this.props.ageGroups as MemberAgeGroups[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
        })

        let groupTypes: JSX.Element[] =  (this.props.groupTypes as MemberGroupTypes[]).map(x => {
            return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
        })

        let priceValues: JSX.Element[] = (this.props.priceValues as number[]).map(x => {
            return <MenuItem key={x} value={x}>{`€ ${x.toFixed(2).replace('.',',')}`}</MenuItem>
        })

        let tableColumns = columnNames.map(x => {
            return <TableCell key={x}>{x}</TableCell>
        })

        let rows: JSX.Element[] = (this.props.additionalPriceDefinitions as EventAdditionalPriceDefinitions[]).map(x => {
            return <TableRow key={x.id}>
                <TableCell>{x.eventAdditionalPriceTypeName}</TableCell>
                <TableCell>{x.description}</TableCell>
                <TableCell>{x.memberGroupTypeName}</TableCell>
                <TableCell>{x.memberAgeGroupName}</TableCell>
                <TableCell>{x.limitCount}</TableCell>
                <TableCell>{`€ ${typeof x.priceValue != 'undefined' && x.priceValue ? x.priceValue.toFixed(2).replace('.',',') : '0,-'}`}</TableCell>
                <TableCell>
                    <EditIcon className='icon' onClick={() => {
                        this.props.changeMethod('Edit')
                        this.props.changeObject(x)
                        this.props.showModal()
                    }}/>
                    <CloseIcon className='icon' onClick={() => {
                        this.props.delete(x.id)
                    }}/>
                </TableCell>
            </TableRow>
        })

        return (
            <>
            <div className='card'>
                <div className='card-header'>
                    Optionen
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-3 col-xs-3 d-flex'>
                            <Button 
                                variant='contained' 
                                color='primary' 
                                className='btnBlue' 
                                onClick={() => {
                                    this.props.changeMethod('Submit')
                                    this.props.showModal()
                                }}>Hinzufügen</Button>
                        </div>
                    </div>
                    <hr/>
                    <strong>Filter:</strong>
                    <div className='row mt-3'>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Option
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='eventAdditionalPriceTypeId'
                                    value={typeof this.props.filter.eventAdditionalPriceTypeId !== 'undefined' ? this.props.filter.eventAdditionalPriceTypeId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {eventAdditionalPriceTypes}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Altersklasse
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='memberAgeGroupId'
                                    value={typeof this.props.filter.memberAgeGroupId !== 'undefined' ? this.props.filter.memberAgeGroupId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {ageGroups}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Teilnehmergruppe
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='memberGroupId'
                                    value={typeof this.props.filter.memberGroupId !== 'undefined' ? this.props.filter.memberGroupId : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {groupTypes}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-6'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Preis
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='price'
                                    value={typeof this.props.filter.price !== 'undefined' ? this.props.filter.price : ''}
                                    onChange={(e:any) => this.props.handleChangeFilter(e)}
                                    fullWidth >
                                    <MenuItem value="">
                                        <em></em>
                                    </MenuItem>
                                    {priceValues}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='float-right mt-4'>
                        <Button
                            variant='contained'
                            color='primary'
                            className='btnBlue'
                            onClick={() => this.props.fetch(this.props.filter)}
                        >Suchen
                        </Button>
                        <Button
                            className='ml-2 btnBlue'
                            color='primary'
                            variant='contained'
                            onClick={() => this.props.clearFilter()}
                        >Zurücksetzen</Button>
                    </div>
                </div>
            </div>
            <div className='row mt-3'>
                <Table className="objects-table table">
                    <TableHead>
                        <TableRow>
                            {tableColumns}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows}
                    </TableBody>
                </Table>
            </div>
            {
                this.props.modal &&
                <OptionsModal 
                    hide={this.props.hideModal}
                    ageGroups={this.props.ageGroups}
                    groupTypes={this.props.groupTypes}
                    eventAdditionalPriceTypes={this.props.eventAdditionalPriceTypes}
                    change={this.props.change}
                    newObject={this.props.newObject}
                    submit={this.props.submit}
                    validRequiredFields={this.props.validRequiredFields}
                    method={this.props.method}
                    />
            }
            </>
        )
    }
}

export default Options